import { defineNuxtPlugin } from "nuxt/app";
import { toast } from "vue-sonner";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      toast,
    },
  };
});
